<template>
    <div class="FoldingSandard">
        <Title firstName="折标煤" lastName="COAL CONVERSION STANDARD" />
        <!-- <div class="selectMonitor selectMonitor1" @click="tagishow=!tagishow">
            {{tagname}}
            <i class="el-icon-arrow-down"></i>
            <div class="list" v-if="tagishow">
                <SelectList :selectList="tagList" @tabTitle="tabTitletag" keyk="id" keyval="name"/>
            </div>
        </div> -->
        <div class="echarts">
            <div class="selectMonitor" @click="ishow=!ishow">
                {{currentName}}
                <i class="el-icon-arrow-down"></i>
                <div class="list" v-if="ishow">
                    <SelectList :selectList="selectList" @tabTitle="tabTitle" keyk="id" keyval="name"/>
                </div>
            </div>
            <div class="charts" v-if="$store.state.nav == 'overview'">
                <charts id="ratio" :series="seriesOption" :xData="xData" unit="kgce"></charts>
            </div>
            <div class="bottom"></div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
const Title = () => import('../../../../components/title/Title')
const SelectList = () => import('../../../../components/title/selectList.vue')
const Bar = () => import('../../../../components/echarts/bar.vue')
const charts = () => import('../../../../components/echarts/charts.vue')
const Graph = () => import('../../../../components/echarts/graph.vue')

import { getSevenDays, getMonthTime, getMonthDays, getTodayTime, getTodayYesTime  } from '../../../../utils/common/index'
export default {
    data(){
        return {
            chartId:'EnergyAnalysis',
            xData:[],
            seriesData:[],
            total:'',
            seriesOption:[],
            ishow:false,
            tagishow:false,
            tagname:"日",
            currentName:"总(折标煤)",
            tagList:[
                {
                    id:1,
                    name:'日'
                },
                {
                    id:2,
                    name:'月'
                },
            ],
            selectList:[
                {
                    id:1,
                    name:'总(折标煤)'
                },
                {
                    id:2,
                    name:'电'
                },
                {
                    id:3,
                    name:'水'
                },
            ],
            tabIdx:0,  // 切换种类
            currentArr:[], // 当前的图表数组
            allArr:[[[], []], [[], []], [[], []]] ,// 所有的图表数组
        }
    },
    components:{
        Title,
        SelectList,
        Bar,
        charts,
        Graph
    },
    computed:{

    },
    created(){
        this.xData = []
        for(let i = 0; i <= 24; i++){
            this.xData.push((i<10?'0'+i:i)+':00')
        }
        

        this.getCoal()
    },
    methods:{
        tabTitle(item){
            let _this = this
            this.currentName = item.name
            this.tabIdx = item.id - 1
            this.currentArr = this.allArr[this.tabIdx]
            this.seriesOption = [{
                name:"今日",
                type:"line",
                data:_this.currentArr[0]
            },{
                name:"昨日",
                type:"line",
                data:_this.currentArr[1]
            }]
        },
        tabTitletag(item){
            this.tagname = item.name
        },
        async getCoal(){
            let _this = this
            let time = getTodayYesTime()
            let dian = new Date().getHours()
            // 获取总折标煤
            let data = {
                date:`${time.today}T00:00:00Z`,
                powerType:'',
                projectId:this.$store.state.projectId,
                range:'DAY'
            }
            let data2 = {
                date:`${time.yesterday}T00:00:00Z`,
                powerType:'',
                projectId:this.$store.state.projectId,
                range:'DAY'
            }
            let res = await Promise.all([
                _this.$http.getConvertedStandardCoal(data), 
                _this.$http.getConvertedStandardCoal(data2)
            ])
            console.log(res);
            // if(res.data.code == 200){
                let electricity = res[0].data.data.result.electricity.map(item =>{
                    return item = Number(item).toFixed(2)
                }).slice(0,dian)
                let water = res[0].data.data.result.water.map(item =>{
                    return item = Number(item).toFixed(2)
                }).slice(0,dian)

                let electricityYes = res[1].data.data.result.electricity.map(item =>{
                    return item = Number(item).toFixed(2)
                })
                let waterYes = res[1].data.data.result.water.map(item =>{
                    return item = Number(item).toFixed(2)
                })

                let all = res[0].data.data.result.total.map(item =>{
                    return item = Number(item).toFixed(2)
                }).slice(0,dian)
                let allYes = res[1].data.data.result.total.map(item =>{
                    return item = Number(item).toFixed(2)
                })

                this.allArr = [[all, allYes], [electricity, electricityYes], [water, waterYes]]
            // }
                console.log(res);
            this.tabTitle(this.selectList[0])
        }
        
    }
}
</script>

<style lang="less" scoped>
    
    .FoldingSandard{
        width: 20vw;
        // height: 493rem;
        position: fixed;
        top: 68.1vh;
        left: 2vw;
        z-index: 1;
        
        

        .list{
            height: 10.5vh;
            width: 20vw;
            position: absolute;
            right: 0;
            top: 100%;
            z-index: 11;
            text-align: left;
        }
        .selectMonitor{
            height: 3vh;
            line-height: 3vh;
            text-align: right;
            padding-right: 0.5vw;
            color: #E6F3FD ;
            cursor: pointer;
            position: absolute;
            right: 0;
            z-index: 99;
        }
        .selectMonitor1{
            position: absolute;
            top: 2px;
            right: auto;
            left: 73px;
            .list{
                right: auto;
                left: -12px;
                width: 56px;
                text-align: center; 
                /deep/ .every{
                    padding-left: 3rem;
                }
            }
        }
        .echarts{
            overflow: hidden;
            position: relative;
            height: 25vh;
            padding-bottom: 1vh;
            background:  linear-gradient(0deg, rgba(0, 33, 59, 0.6) 0%, rgba(3, 13, 24, 0.7) 100%);

            
            .charts{
                height: 100%;
                padding: 2vh 0 1vh;
            }
            .bottom{
                width: 20vw;
                height: 1vh;
                background: url(../../../../assets/img/板块装饰线.png) no-repeat;
                block-size: 100% 100%;
                position: absolute;
                bottom: 0;
                left: 0;
            }
        }

        
    }

</style>